<script lang="ts" setup generic="TCell, TRowData">
import type { ICellRendererParamsWithIconAndAction } from '../Classes/params';
import { ButtonComp } from '@/components';
import { ref } from 'vue';

const props = defineProps<ICellRendererParamsWithIconAndAction<TCell, TRowData>>();

// Helper property for the toggle icon
const isDetailExpanded = ref(false);

/**
 * Toggle the detail grid
 */
const toggleDetailGrid = () => {
    isDetailExpanded.value = !isDetailExpanded.value;

    if (isDetailExpanded.value) {
        props.grid.expandDetailGrid(props.rowId);
    } else {
        props.grid.collapseDetailGrid(props.rowId);
    }
};
</script>

<template>
    <div
        class="d-flex flex-nowrap h-100 gap-2 row-action-buttons"
        v-if="action || props.hasDetailGrid === true"
    >
        <ButtonComp
            class="btn-sm p-0 no-focus"
            v-if="action"
            button-type="Custom"
            :icon="props.icon"
            @click.stop="action(value)"
        />
        <ButtonComp
            v-if="props.hasDetailGrid === true"
            class="btn-sm p-0 no-focus"
            button-type="Custom"
            :icon="isDetailExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"
            @click.stop="toggleDetailGrid"
        />
    </div>
</template>
